import { useEffect, useState } from "react";
import "../css/Inversiones.css"
import useAuth from '../hooks/useAuth';
import axios from "../api/axios"
import { Dialog, DialogTitle, DialogContent, IconButton, DialogActions, Button, Avatar, Backdrop, CircularProgress, Box, Paper, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Typography, TableFooter, useMediaQuery, useTheme, Card, CardContent, Chip, Divider } from "@mui/material";
import ExportButtons from './ExportButtons';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InfoIcon from '@mui/icons-material/Info';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function Inversiones(props) {
    const [rows, setRows] = useState([])
    const [seleccion, setSeleccion] = useState(0)
    const { auth, setAuth } = useAuth();
    const [totalInvertido, setTotalInvertido] = useState("0.00")
    const [totalBalance, setTotalBalance] = useState("0.00")
    const [procesando, setProcesando] = useState(false)
    const [openInfo, setOpenInfo] = useState(false)
    const [pagina, setPagina] = useState(0)
    const [comportamiento, setComportamiento] = useState([])
    const [historial, setHistorial] = useState([])

    const [infoRow, setInfoRow] = useState(null)

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    useEffect(() => {
        actRows();
    }, [])

    useEffect(()=>{
        if (seleccion>0){
            const r = rows.filter((row)=>row.id==seleccion)
            if (r.length>0){
                setInfoRow(r[0])
            }
            
        }
        
    }, [seleccion])

    

    const handleSeleccion = (cual) => {
        setSeleccion(cual)
    }

    const handleOpenInfo = ()=>{
        setOpenInfo(true)
        actComportamiento();
        actHistorial()
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const actComportamiento = async () => {
        let cliente = infoRow?.cliente;
        if (cliente == null || cliente == undefined) { setComportamiento([]); return; }
        if (cliente == 0) { setComportamiento([]); return; }
        console.log("revisando comportamiento...")
        setProcesando(true)
        let params = new URLSearchParams();

        params.append("cual", cliente);
        var options = {
            method: "POST",
            body: params
        }
        try {
            const response = await fetch("/api/dashboard/comportamiento", options);
            if (response.ok) {
                const data = await response.json();
                if (data.respuesta == "S") {
                    console.log(data)
                    setComportamiento(data.lista)
                }
            } else {
                console.log("no se pudo", response.statusText)
            }
        } catch (error) {
            console.log(error)
        }
        setProcesando(false)
    }

    const actHistorial = async () => {
        let cliente = infoRow?.cliente;
        if (cliente == null || cliente == undefined) { setHistorial([]);return; }
        if (cliente == 0) { setHistorial([]); return; }
        setProcesando(true)
        let params = new URLSearchParams();

        params.append("cual", cliente);
        var options = {
            method: "POST",
            body: params
        }
        try {
            const response = await fetch("/api/dashboard/historial", options);
            if (response.ok) {
                const data = await response.json();
                if (data.respuesta == "S") {
                    console.log(data)
                    setHistorial(data.lista)
                }
            } else {
                console.log("no se pudo", response.statusText)
            }
        } catch (error) {
            console.log(error)
        }
        setProcesando(false)
    }

    const objInfo = () => {
        return (
            <Dialog
                open={openInfo}
                fullWidth
                maxWidth="md"
                fullScreen={isMobile}
                PaperProps={{
                    sx: {
                        m: isMobile ? 0 : 2,
                        maxHeight: isMobile ? '100%' : '90vh'
                    }
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    py: isMobile ? 1.5 : 2,
                    fontSize: isMobile ? '1rem' : '1.25rem'
                }}>
                    Detalles del Cliente
                </DialogTitle>
                <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
                    <div className={isMobile ? "dsh-datos-mobile" : "dsh-datos"}>
                        <div className={isMobile ? "dsh-datos-head-mobile" : "dsh-datos-head"}>
                            <div style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                                <Avatar sx={{ width: isMobile ? 80 : 120, height: isMobile ? 80 : 120 }} alt="Foto Cliente" src={"https://droidsd.credi-cloud.com/api/clientes/verfoto?cliente=" + infoRow?.cliente + "&cache=a"} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", textAlign: isMobile ? 'center' : 'left' }}>
                                <div className="dsh-datos-nombre" style={{ fontSize: isMobile ? '14px' : '16px' }}>{infoRow?.nombre + " " + infoRow?.apellido}</div>
                                <div className="dsh-datos-empresa">{infoRow?.empresa}</div>
                                <div className="dsh-datos-frecuencia">{"Frecuencia: " + infoRow?.frecuencia}</div>
                            </div>
                        </div>
                        <div>
                            <Box sx={{ width: '100%' }}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs
                                        value={pagina}
                                        onChange={handleChange}
                                        variant={isMobile ? "fullWidth" : "standard"}
                                        sx={{
                                            '& .MuiTab-root': {
                                                fontSize: isMobile ? '0.75rem' : '0.875rem',
                                                minHeight: isMobile ? 40 : 48
                                            }
                                        }}
                                    >
                                        <Tab label="Comportamiento" {...a11yProps(0)} />
                                        <Tab label="Seguimientos" {...a11yProps(1)} />
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={pagina} index={0}>
                                    <div className={isMobile ? "dsh-datos-comp-rows-mobile head" : "dsh-datos-comp-rows head"}>
                                        <div>#</div>
                                        <div>Fecha</div>
                                        <div>Monto</div>
                                        <div>Pago</div>
                                        {!isMobile && <div></div>}
                                    </div>
                                    {
                                        comportamiento.map((row) => {
                                            var monto = parseFloat(row.monto).toFixed(2)
                                            var pagos = parseFloat(row.pagos).toFixed(2)
                                            return (
                                                <div className={(isMobile ? "dsh-datos-comp-rows-mobile " : "dsh-datos-comp-rows ") + (monto > pagos ? " mal " : "")} key={row.numero}>
                                                    <div>{row.numero}</div>
                                                    <div>{row.fecha}</div>
                                                    <div>{parseFloat(row.monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                    <div>{parseFloat(row.pagos).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                    {!isMobile && <div><IconButton size="small"><img className="dsh-error" src={(monto > pagos && pagos == 0 ? "error.png" : (pagos > 0 && monto > pagos ? "warning.png" : "ok.png"))} /></IconButton></div>}
                                                </div>
                                            )
                                        })
                                    }
                                </CustomTabPanel>
                                <CustomTabPanel value={pagina} index={1}>
                                    <div className={isMobile ? "dsh-datos-hist-rows-mobile head" : "dsh-datos-hist-rows head"}>
                                        <div>Fecha</div>
                                        <div>Comentario</div>
                                    </div>
                                    {
                                        historial.map((row) => {
                                            return (
                                                <div className={isMobile ? "dsh-datos-hist-rows-mobile" : "dsh-datos-hist-rows"} key={row.fecha}>
                                                    <div>{row.fecha}</div>
                                                    <div>{row.comentario}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </CustomTabPanel>
                            </Box>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions sx={{ p: isMobile ? 1.5 : 2 }}>
                    <Button
                        onClick={() => setOpenInfo(false)}
                        variant="contained"
                        fullWidth={isMobile}
                        sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                            }
                        }}
                    >
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const actRows = async () => {
        let mRows = []
        let total = 0.00;
        let bal = 0.00;
        setProcesando(true)
        try {
            const respuesta = await axios.get("inversiones/lista?cual=" + auth.inversionista + "&estatus=" + props.estatus, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta == "S") {
                for (var i = 0; i < data.lista.length; i++) {
                    bal = bal + parseFloat(data.lista[i].prestamo_balance)
                    total = total + parseFloat(data.lista[i].inversion_balance)
                    mRows.push({
                        id: data.lista[i].id,
                        cliente: data.lista[i].cliente,
                        nombre: data.lista[i].nombre,
                        apellido: data.lista[i].apellido,
                        empresa: data.lista[i].empresa,
                        estatus_cobro: data.lista[i].estatus_cobro,
                        estatus: data.lista[i].estatus,
                        fecha: data.lista[i].fecha,
                        frecuencia: data.lista[i].frecuencia,
                        monto: parseFloat(parseFloat(data.lista[i].monto).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 }),
                        invertido: parseFloat(parseFloat(data.lista[i].invertido).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 }),
                        prestamoBalance: parseFloat(parseFloat(data.lista[i].prestamo_balance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 }),
                        inversionBalance: parseFloat(parseFloat(data.lista[i].inversion_balance).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })
                    })
                }
            }
        } catch (error) {
            console.log(error)
        }

        setRows(mRows)
        setTotalBalance(bal)
        setTotalInvertido(total)
        setProcesando(false)
    }

    const handleChange = (event, newValue) => {
        setPagina(newValue);
    };



    // Vista de cards para móvil
    const renderMobileCards = () => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {rows.map((item) => (
                <Card
                    key={item.id}
                    sx={{
                        cursor: 'pointer',
                        border: item.id === seleccion ? '2px solid #1e3a5f' : '1px solid #e0e0e0',
                        '&:hover': { boxShadow: 3 }
                    }}
                    onClick={() => { handleSeleccion(item.id) }}
                >
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.85rem' }}>
                                    {item.nombre + ' ' + item.apellido}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {item.fecha}
                                </Typography>
                            </Box>
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleSeleccion(item.id); handleOpenInfo(); }}>
                                <InfoIcon fontSize="small" />
                            </IconButton>
                        </Box>
                        <Divider sx={{ my: 0.5 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Box>
                                <Typography variant="caption" color="text.secondary" display="block">
                                    Balance Invertido
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#1e3a5f' }}>
                                    RD$ {item.inversionBalance}
                                </Typography>
                            </Box>
                            <Box sx={{ textAlign: 'right' }}>
                                <Chip
                                    label={item.estatus_cobro}
                                    size="small"
                                    sx={{
                                        fontSize: '0.65rem',
                                        height: 20,
                                        backgroundColor: item.estatus_cobro === 'AL DIA' ? '#e8f5e9' : '#ffebee',
                                        color: item.estatus_cobro === 'AL DIA' ? '#2e7d32' : '#c62828'
                                    }}
                                />
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );

    // Vista de tabla para desktop/tablet
    const renderTable = () => (
        <TableContainer component={Paper} sx={{ height: isTablet ? "400px" : "600px" }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{
                            py: 1.25,
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            borderBottom: '2px solid #d4af37'
                        }}></TableCell>
                        <TableCell sx={{
                            py: 1.25,
                            fontSize: isTablet ? '0.75rem' : '0.8rem',
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            borderBottom: '2px solid #d4af37'
                        }}>Fecha</TableCell>
                        <TableCell sx={{
                            py: 1.25,
                            fontSize: isTablet ? '0.75rem' : '0.8rem',
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            borderBottom: '2px solid #d4af37'
                        }}>Cliente</TableCell>
                        {!isTablet && <TableCell sx={{
                            py: 1.25,
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            borderBottom: '2px solid #d4af37'
                        }}>Condicion</TableCell>}
                        <TableCell sx={{
                            py: 1.25,
                            fontSize: isTablet ? '0.75rem' : '0.8rem',
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            borderBottom: '2px solid #d4af37'
                        }}>Estatus</TableCell>
                        {!isTablet && <TableCell align="right" sx={{
                            py: 1.25,
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            borderBottom: '2px solid #d4af37'
                        }}>Monto Prestamo</TableCell>}
                        {!isTablet && <TableCell align="right" sx={{
                            py: 1.25,
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            borderBottom: '2px solid #d4af37'
                        }}>Balance Prestamo</TableCell>}
                        <TableCell align="right" sx={{
                            py: 1.25,
                            fontSize: isTablet ? '0.75rem' : '0.8rem',
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            borderBottom: '2px solid #d4af37'
                        }}>Invertido</TableCell>
                        <TableCell align="right" sx={{
                            py: 1.25,
                            fontSize: isTablet ? '0.75rem' : '0.8rem',
                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                            color: 'white',
                            fontWeight: 600,
                            borderBottom: '2px solid #d4af37'
                        }}>Balance</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((item, index) => (
                        <TableRow key={item.id} hover onClick={() => { handleSeleccion(item.id) }} selected={item.id == seleccion}>
                            <TableCell sx={{ py: 0.5 }}><IconButton size="small" onClick={handleOpenInfo}><InfoIcon fontSize="small" /></IconButton></TableCell>
                            <TableCell sx={{ py: 0.5, fontSize: isTablet ? '0.7rem' : '0.875rem' }}>{item.fecha}</TableCell>
                            <TableCell sx={{ py: 0.5, fontSize: isTablet ? '0.7rem' : '0.875rem' }}>{item.nombre + ' ' + item.apellido}</TableCell>
                            {!isTablet && <TableCell sx={{ py: 0.5 }}>{item.estatus}</TableCell>}
                            <TableCell sx={{ py: 0.5, fontSize: isTablet ? '0.7rem' : '0.875rem' }}>{item.estatus_cobro}</TableCell>
                            {!isTablet && <TableCell align="right" sx={{ py: 0.5 }}>{item.monto}</TableCell>}
                            {!isTablet && <TableCell align="right" sx={{ py: 0.5 }}>{item.prestamoBalance}</TableCell>}
                            <TableCell align="right" sx={{ py: 0.5, fontSize: isTablet ? '0.7rem' : '0.875rem' }}>{item.invertido}</TableCell>
                            <TableCell align="right" sx={{ py: 0.5, fontSize: isTablet ? '0.7rem' : '0.875rem' }}>{item.inversionBalance}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={isTablet ? 2 : 2} sx={{ fontSize: isTablet ? '0.7rem' : '0.875rem' }}>{"Total: " + rows.length.toString()}</TableCell>
                        <TableCell></TableCell>
                        {!isTablet && <TableCell></TableCell>}
                        <TableCell></TableCell>
                        {!isTablet && <TableCell></TableCell>}
                        {!isTablet && <TableCell align="right">{totalBalance.toLocaleString('en-US', { minimumFractionDigits: 2 })}</TableCell>}
                        <TableCell></TableCell>
                        <TableCell align="right" sx={{ fontSize: isTablet ? '0.7rem' : '0.875rem', fontWeight: 'bold' }}>{totalInvertido.toLocaleString('en-US', { minimumFractionDigits: 2 })}</TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );

    return (
        <Box sx={{ minHeight: "100vh", px: isMobile ? 1 : 0 }}>
            {objWait()}
            {objInfo()}
            <Typography variant={isMobile ? "h6" : "h5"} sx={{ mb: 1, color: '#1e3a5f', fontWeight: 600 }}>
                Mis inversiones
            </Typography>

            {/* Resumen en móvil */}
            {isMobile && (
                <Paper sx={{ p: 1.5, mb: 2, background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                Total Invertido
                            </Typography>
                            <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                                RD$ {totalInvertido.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                Inversiones
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#d4af37', fontWeight: 'bold' }}>
                                {rows.length}
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
            )}

            {!isMobile && (
                <ExportButtons
                    data={rows}
                    columns={[
                        { header: 'Fecha', field: 'fecha' },
                        { header: 'Cliente', field: 'nombre' },
                        { header: 'Condicion', field: 'estatus' },
                        { header: 'Estatus', field: 'estatus_cobro' },
                        { header: 'Monto Prestamo', field: 'monto', type: 'money' },
                        { header: 'Balance Prestamo', field: 'prestamoBalance', type: 'money' },
                        { header: 'Monto Invertido', field: 'invertido', type: 'money' },
                        { header: 'Balance Invertido', field: 'inversionBalance', type: 'money' }
                    ]}
                    filename="inversiones"
                    title="Mis Inversiones"
                />
            )}

            {/* Contenido principal */}
            <Box sx={{ height: isMobile ? 'calc(100vh - 200px)' : 'auto', overflow: 'auto' }}>
                {isMobile ? renderMobileCards() : renderTable()}
            </Box>
        </Box>
    )
}